class Checkout {
  constructor() {
    this.testMode = ( mode === 'test' )
    this.stripe = Stripe( this.testMode ? 'pk_test_ZMiGTFKE0xuxwdxrJEp5rYFE' : 'pk_live_7sHwahzx2PzUYLOBy6JD4mOU' )
    this.ajaxURL = '/software/stripe_ajax_r5.php'
    this.cardNumber = null
    this.$win = $( window )
    this.currentStep = 1
    this.stepnames = [ 'checkout-contact-info', 'checkout-billing-info', 'checkout-review', 'checkout-purchase-confirmed' ]
    this.css_stepnames = [ 'contact', 'billing', 'review', 'complete' ]
    this.hasPushState = ( history.pushState != undefined )
    this.defaultBtnText = ''
    this.upgradeData = {}
    this.paymentAttempts = 0
    this.$details = null
    this.interactions = 0
    this.page_started = new Date().getTime()
    this.cardBrand = ''
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
    this.initStripeElements()
    this.initValidation()
    if ( this.testMode ) {
      $( 'body' ).append( '<div id="mode_indicator" style="padding:4px 8px;background:#cccc00;color:#000;position:absolute;top:0;left:0;z-index:9999">Test mode</div>' )
    }
  }

  cacheDOM () {
    this.$details = $( '#order-details-training' )
    this.$submitCard = $( '#submit-card' )
    this.$cardErrors = $( '#card-errors' )
  }

  bindEvents () {
    $( document ).on( 'mousedown touchstart press focusin', () => { this.interactions++ } )

    $( '.checkout-steps li' ).on( 'click', ( e ) => {
      var $this = $( e.currentTarget )
      if ( !$this.hasClass( 'done' ) ) return false
      var goTo = $this.index()
      $( '.checkout-steps' ).each( function () {
        $( this ).find( 'li' ).each( function ( i ) {
          if ( i > goTo ) $( this ).removeClass( 'done completed' )
        } )
      } )
      this.goToStep( goTo )
    } )

    $( '#submit-info' ).on( 'click', () => { this.checkExistingCustomer() } )

    $( '.close-modal' ).on( 'click', ( e ) => {
      this.upgradeData = {}
      $.colorbox.close()
      return false
    } )

    $( 'input#academy_included' ).on( 'change', function () {
      if ( $( this ).val() == '1' ) $( 'button#add-training' ).addClass( 'hidden' )
      else $( 'button#add-training' ).removeClass( 'hidden' )
    } )

    $( '#modify_order' ).on( 'click', () => { this.openModifyOrder() } )
    $( 'button#add-training' ).on( 'click', () => {
      $.colorbox( { href: 'modify_order.two-one.php?action=add_academy', iframe: true, width: '94%', height: '400px', maxHeight: '90%' } )
    } )

    $( 'input[data-expand]' ).each( function () {
      var $el = $( this ), targ = $( '#' + $el.attr( 'data-expand' ) )
      $el.on( 'change', function () {
        targ.toggleClass( 'collapsed' )
        $el.parent().toggleClass( 'hidden' )
        if ( !targ.hasClass( 'collapsed' ) ) targ.find( 'input' ).first().focus()
      } )
    } )

    $( 'input[required]' ).blur( function () { $( this ).valid() } )

    $( 'button.next-step' ).each( ( index, elem ) => {
      var fs = $( elem ).parents( 'fieldset' )
      $( elem ).on( 'click', () => {
        var $btn = $( elem )
        if ( !$btn.is( ':visible' ) ) return false
        var valid = true
        var $firstError = null
        fs.find( 'input[required]' ).each( function () {
          if ( !$( this ).valid() ) {
            valid = false
            if ( !$firstError ) $firstError = $( this )
          }
        } )
        if ( this.currentStep == 2 ) {
          if ( !this.stripeComplete.number || !this.stripeComplete.expiry || !this.stripeComplete.cvc ) {
            this.$cardErrors.html( 'Please correct the errors below to continue.' ).removeClass( 'hidden' ).css( 'display', 'flex' )
            valid = false
            if ( !$firstError ) $firstError = this.$cardErrors
          }
        }
        if ( valid ) this.completeStep( this.currentStep )
        else {
          if ( $firstError ) $firstError[ 0 ].scrollIntoView( { behavior: 'smooth', block: 'center' } )
          fs.animateAndReset( 'shake' )
        }
        $btn.blur()
        return false
      } )
    } )

    $( 'button#submitpayment' ).on( 'captcha-complete', ( e, data ) => {
      e.preventDefault()
      this.handleSubmitPayment( data )
      return false
    } )

    $( '.collapsed' ).on( 'focusin', function () {
      if ( $( this ).hasClass( 'collapsed' ) ) $( this ).parents( 'fieldset' ).find( 'button' ).focus()
    } )

    $( ':input' ).one( 'change', () => {
      this.$win.on( 'beforeunload', () => {
        return 'You have unsaved changes. Do you want to leave and discard your changes or stay on this page?'
      } )
    } )

    $( 'a.lightbox' ).colorbox( { iframe: true, width: '80%', height: '80%' } )

    this.$win.on( 'hashchange', () => { this.handleHashChange() } )
    $( window ).on( 'popstate', () => { this.modifyOrder( this.unserialize( location.search.substr( 1 ) ), true ) } )

    $( document ).on( 'click', '.prev-step', this.backToStep.bind( this ) )
  }

  initValidation () {
    var inputs = $( 'input' )
    inputs.not( '[required]' ).not( '[type=checkbox]' ).parents( 'p' ).addClass( 'optional' )
    $.validator.messages.required = 'This field is required'
    $.validator.messages.minlength = 'invalid entry'
    $( 'form' ).validate( {
      rules: {
        firstname: { required: true },
        email: { required: true, email: true },
        'cardholder-name': { required: true }
      },
      invalidHandler: function ( event, validator ) {
        var $el = $( validator.errorList[ 0 ].element )
        $el[ 0 ].scrollIntoView( { behavior: 'smooth', block: 'center' } )
        $el.focus()
      },
      highlight: function ( element ) {
        $( element ).closest( '.input-wrap' ).addClass( 'error' )
      },
      unhighlight: function ( element ) {
        $( element ).closest( '.input-wrap' ).removeClass( 'error' )
      },
      errorPlacement: function ( error, element ) {
        element.closest( '.input-wrap' ).append( error )
      }
    } )
  }

  completeStep ( num ) {
    var $steps = $( '.checkout-steps' )
    $steps.each( function () {
      $( this ).find( 'li' ).eq( num - 1 ).addClass( 'done completed' )
      $( this ).find( 'li' ).eq( num ).addClass( 'completed' )
    } )

    if ( num === 2 ) this.populateReview()
    this.goToStep( num )

  }

  populateReview () {
    var $review = $( '#review' )
    var firstname = $( '#firstname' ).val()
    var lastname = $( '#lastname' ).val()
    var fullName = [ firstname, lastname ].filter( Boolean ).join( ' ' )
    $review.find( '.review-name' ).text( fullName )
    $review.find( '.review-email' ).text( $( '#email' ).val() )
    var invoiceDetails = $( '#invoice_details' ).val()
    $review.find( '.review-invoice-details' ).text( invoiceDetails || '' )
    this.stripe.createToken( this.cardNumber ).then( ( result ) => {
      if ( result.token && result.token.card ) {
        var card = result.token.card
        $review.find( '.review-cardholder' ).text( 'Ending in ' + card.last4 )
        $review.find( '.review-card-brand' ).text( 'Expires ' + String( card.exp_month ).padStart( 2, '0' ) + '/' + String( card.exp_year ).slice( -2 ) )
      }
    } )
  }

  goToStep ( num ) {
    this.updateHash( num )
    var forward = num >= this.currentStep
    this.currentStep = num + 1
    $( 'body' ).removeClass( function ( index, className ) {
      // Matches any class starting with 'step-'
      return ( className.match( /(^|\s)step-\S+/g ) || [] ).join( ' ' )
    } ).addClass( 'step-' + num ).addClass( 'step-' + this.css_stepnames[ num ] )
    $( 'fieldset' ).removeClass( 'backwards' ).removeClass( 'active' )
    if ( this.currentStep < 3 ) {
      var ondeck = $( 'fieldset.step-' + this.currentStep ).addClass( 'active' )
      if ( !forward ) ondeck.addClass( 'backwards' )
      ondeck.animateAndReset( 'transin' )
    } else {
      $( '#review' ).addClass( 'active' ).animateAndReset( 'transin' )
    }
    $.scrollTo( $( '#progress' ), 500, { axis: 'y' } )
    this.trackStep( num )
  }

  trackStep ( num ) {
    try {
      var stepname = this.stepnames[ num ]
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push( {
        'event': 'virtualPageview',
        'pagePath': 'https://ajarproductions.com/pages/products/in5/' + stepname + '/',
        'pageTitle': 'in5 Checkout | ' + stepname + ' | Ajar Productions',
        'hostname': 'ajarproductions.com'
      } )
    } catch ( err ) { }
  }

  updateHash ( num ) {
    var stepname = this.stepnames[ num ]
    var hashStr = '#step=' + stepname
    if ( location.hash.indexOf( hashStr ) > -1 ) return
    if ( this.hasPushState ) history.pushState( {}, 'Checkout Step: ' + ( num + 1 ), hashStr )
    else location.hash = hashStr
  }

  handleHashChange () {
    var stepname = unescape( location.hash.split( '#' ).join( '' ).split( 'step=' ).join( '' ).split( '+' ).join( ' ' ) )
    if ( !stepname.length ) stepname = this.stepnames[ 0 ]
    var i = this.stepnames.length
    while ( i-- ) {
      if ( this.stepnames[ i ] == stepname ) { this.goToStep( i ); break }
    }
    var oldPlanID = plan_id.split( 'in5.v3' ).join( '' )
    var urlData = this.unserialize( location.search.substr( 1 ) )
    if ( urlData.plan != oldPlanID ) this.modifyOrder( urlData, true )
  }

  initStripeElements () {
    var elements = this.stripe.elements()
    var style = {
      base: {
        color: '#222',
        lineHeight: '48px',
        fontFamily: 'Jost, "Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': { color: '#999' }
      },
      invalid: { color: '#fa755a', iconColor: '#fa755a' }
    }
    this.cardNumber = elements.create( 'cardNumber', { style: style } )
    this.cardExpiry = elements.create( 'cardExpiry', { style: style } )
    this.cardCvc = elements.create( 'cardCvc', { style: style } )
    this.cardNumber.mount( '#card-number' )
    this.cardExpiry.mount( '#card-expiry' )
    this.cardCvc.mount( '#card-cvc' )
    this.$submitCard.addClass( 'disabled' )
    this.stripeComplete = { number: false, expiry: false, cvc: false }

    this.cardNumber.on( 'change', ( e ) => {
      this.stripeComplete.number = e.complete
      if ( e.brand ) this.cardBrand = e.brand
      this.showStripeError( '#card-number', e )
    } )
    this.cardExpiry.on( 'change', ( e ) => {
      this.stripeComplete.expiry = e.complete
      this.showStripeError( '#card-expiry', e )
    } )
    this.cardCvc.on( 'change', ( e ) => {
      this.stripeComplete.cvc = e.complete
      this.showStripeError( '#card-cvc', e )
    } )
  }

  showStripeError ( selector, event ) {
    var $wrap = $( selector ).closest( '.input-wrap' )
    var $error = $wrap.find( '.stripe-error' )
    if ( !$error.length ) $error = $( '<label class="stripe-error error"></label>' ).appendTo( $wrap )
    if ( event.error ) {
      $error.text( event.error.message ).show()
      $wrap.addClass( 'error' )
    } else {
      $error.text( '' ).hide()
      $wrap.removeClass( 'error' )
    }
    if ( this.stripeComplete.number && this.stripeComplete.expiry && this.stripeComplete.cvc ) {
      this.$submitCard.removeClass( 'disabled' )
    } else {
      this.$submitCard.addClass( 'disabled' )
    }
  }

  handleSubmitPayment ( data ) {
    $( 'body' ).removeClass( 'error' ).addClass( 'submitting' )
    try {
      if ( !this.testMode ) {
        if ( localStorage.getItem( 'banned' ) == '1' ) {
          $( 'button' ).remove()
          alert( 'You have been flagged for malicious usage.' )
          return false
        }
        if ( this.logAndCheckAttempts() === false ) {
          alert( 'You have been flagged for making too many attempts and are locked out of this page.' )
          $( 'button' ).remove()
          return false
        }
        if ( ++this.paymentAttempts > 5 ) {
          alert( "You've exceeded the maximum number of attempts. Please try again at another time." )
          $( 'button' ).remove()
          return false
        }
      }
    } catch ( err ) { console.log( 'issue logging payment attempt' ) }
    this.stripeToken( data )
  }

  stripeToken ( data ) {
    this.stripe.createToken( this.cardNumber ).then( ( result ) => {
      if ( result.error ) this.paymentError( result.error.message, result.error.decline_code )
      else this.stripeTokenHandler( result.token, data )
    } )
  }

  stripeTokenHandler ( token, in_data ) {
    if ( this.interactions < 5 || ( ( new Date().getTime() ) - this.page_started < 10500 ) ) {
      alert( 'Sorry. We currently cannot distinguish you from a bot. Please contact us at support@ajarproductions.com if you feel this is in error.' )
      $( 'button' ).remove()
      return false
    }

    if ( plan_id == 'in5.v3.b.1.m' && $( 'input#email' ).val().match( /@(g|hot)mail.com/i ) ) {
      var entered_email = prompt( 'For security purposes, please re-enter your email address to confirm' )
      if ( entered_email !== $( 'input#email' ).val() ) {
        alert( 'Sorry. We could not confirm your email address. Please contact us at support@ajarproductions.com if you feel this is in error.' )
        $( 'button' ).remove()
        return false
      }
    }

    var $form = $( 'form' )
    this.defaultBtnText = $form.find( '#submit_btn_text' ).text()
    var submit_action = 'new_in5_subscription'
    switch ( this.upgradeData.type ) {
      case 'upgrade': submit_action = 'upgrade_in5_subscription'; break
      case 'reactivate': submit_action = 'reactivate_in5_subscription'; break
    }

    var obj = $( {
      'token': token.id, 'action': submit_action, 'upgrade_data': this.upgradeData,
      'plan_id': plan_id, 'offer': offer_str, 'verify': offer_verify, 'mode': mode,
      'payment_intent': ( in_data && in_data.payment_intent ) ? in_data.payment_intent : null,
      'subscription': ( in_data && in_data.subscription ) ? in_data.subscription : null,
      'captcha_token': ( in_data && in_data.captcha_token ) ? in_data.captcha_token : null,
      'auth_invoice': auth, 'qty': qty, 'source': 'checkout-r2'
    } )
    obj.addValueToObject( 'input#firstname', 'firstname' )
      .addValueToObject( 'input#lastname', 'lastname' )
      .addValueToObject( 'input#user', 'user_check' )
      .addValueToObject( 'input#email', 'email' )
      .addValueToObject( 'input#newsletter', 'newsletter' )
      .addValueToObject( 'textarea#invoice_details', 'invoice_details' )
      .addValueToObject( 'input#academy_included', 'academy_included' )
      .addValueToObject( 'input#academy_included_plan', 'academy_included_plan' )
      .addValueToObject( 'input#academy_included_period', 'academy_included_period' )
      .addValueToObject( 'input#academy_included_users', 'academy_included_users' )

    $( 'body' ).addClass( 'complete' ).removeClass( 'error' ).find( '#submit_btn_text' ).text( 'Processing your order...' )
    $.post( this.ajaxURL, obj[ 0 ], ( data ) => {
      if ( this.testMode ) console.log( 'success: ' + JSON.stringify( data ) )
      if ( data.success ) {
        if ( this.upgradeData.type ) {
          $( '.order_serial' ).parent().hide()
          if ( data.invoice_num ) $( '.order_number' ).text( data.invoice_num )
          else $( '.order_number' ).parent().hide()
        } else {
          $( '.order_serial' ).text( data.serial )
          $( '.order_number' ).text( data.order )
        }
        if ( !data.invoice ) $( '#print_invoice' ).addClass( 'hidden' )
        else $( '#print_invoice' ).wrap( '<a class="nohover" target="blank" href="https://ajarproductions.com/software/invoice/?stripe_inv=' + data.invoice + '&mode=' + mode + '"></a>' )
        this.completePayment( data )
      } else {
        var msg = data.message || 'Payment failed.'
        this.paymentError( msg, data.decline_code )
        if ( data.blocked ) {
          localStorage.setItem( 'banned', '1' )
          $( 'button' ).remove()
        } else if ( data.client_key && data.subscription ) {
          this.handle3DS( data.client_key, data.subscription, token )
        }
      }
    }, 'json' ).fail( () => {
      this.paymentError( 'Payment failed. Card may have been declined.' )
    } )
  }

  handle3DS ( client_key, subscription_id, token ) {
    if ( this.testMode ) console.log( 'handle3DS' )
    $( 'body' ).addClass( 'submitting' )
    var lastname = $( 'input#lastname' ).val()
    var fullname = $( 'input#firstname' ).val() + ( lastname.length ? ' ' + lastname : '' )
    this.stripe.confirmCardPayment( client_key, {
      setup_future_usage: 'off_session',
      payment_method: { card: this.cardNumber, billing_details: { name: fullname } }
    } ).then( ( result ) => {
      if ( result.error ) this.paymentError( result.error.message, result.error.decline_code )
      else if ( result.paymentIntent ) {
        this.stripeTokenHandler( token, { 'payment_intent': result.paymentIntent.id, 'subscription': subscription_id } )
      }
    } )
  }

  completePayment ( data ) {
    $( 'body' ).removeClass( 'spin submitting' ).addClass( 'complete confirmation' )
    this.completeStep( 3 )
    this.$win.off( 'beforeunload hashchange' )
    $( '#formwrap' ).addClass( 'hidden' )
    $( '#sidebar' ).addClass( 'hidden' )
    $( '#payment-form' ).addClass( 'hidden' )
    $( '.order_email' ).text( $( '#email' ).val() )
    var firstname = $( '#firstname' ).val()
    $( '.order_firstname' ).each( function ( index, elem ) {
      var nameval = firstname.length ? ( elem.getAttribute( 'data-prefix' ) || '' ) + firstname : ''
      $( elem ).text( nameval )
    } )
    $( '.credit_card_digits' ).text( data.last4 )
    $( '.plan_interval' ).text( plan_int )
    $( '.order_total' ).html( data.amount_paid ? this.getDollarFormat( data.amount_paid ) : $( 'section.order-details .total' ).html() )
    $( '.order_number' ).text( data.order || data.invoice_num )
    if ( this.upgradeData.type ) $( '#activate-account' ).text( 'Login to your account >>' )
    $( '#activate-account' ).on( 'click', () => {
      var accountURL = 'https://ajarproductions.com/account/'
      if ( !this.upgradeData.type ) accountURL += '?activate=' + data.order
      window.location.assign( accountURL )
    } )
    $( 'section#confirmation' ).removeClass( 'hidden' )
    if ( $( 'input#academy_included' ).val() == '1' ) $( '#academy_confirm' ).removeClass( 'hidden' )
    this.trackPayment( data )
  }

  paymentError ( msg, decline_code ) {
    var display = msg
    if ( decline_code ) display += ' (Decline code: ' + decline_code + ')'
    this.$cardErrors.html( display ).removeClass( 'hidden' ).css( 'display', 'flex' )
    $( 'body' ).addClass( 'error' ).removeClass( 'submitting' ).removeClass( 'complete' ).find( '#submit_btn_text' ).text( this.defaultBtnText )
    this.goToStep( 1 )
  }

  trackPayment ( data ) {
    try {
      window.dataLayer = window.dataLayer || []
      var productsGA3 = []
      var productsGA4 = []
      var hasTraining = data.academy_included == '1'
      var revenue = $( '.order_total' ).text().replace( /\$/, '' )
      var software_revenue = revenue

      if ( hasTraining ) {
        var trainingUnitAmount = parseFloat( this.$details.find( '.training-amount' ).text() )
        var training_revenue = trainingUnitAmount * data.academy_included_users
        software_revenue = revenue - training_revenue
        var trainingName = 'academy-' + data.academy_included_plan + '-' + data.academy_included_period
      }

      productsGA3.push( { 'id': plan_id, 'name': $( '.order-details .planName' ).text(), 'price': software_revenue, 'brand': 'ajarproductions.com', 'category': 'subscription software', 'coupon': offer_str, 'quantity': 1 } )
      productsGA4.push( { 'item_id': plan_id, 'item_name': $( '.order-details .planName' ).text(), 'price': software_revenue, 'item_brand': 'ajarproductions.com', 'item_category': 'subscription software', 'coupon': offer_str, 'quantity': 1, 'affiliation': 'in5 checkout page', 'discount': 0.00 } )

      if ( hasTraining ) {
        productsGA3.push( { 'id': trainingName, 'name': trainingName, 'price': training_revenue, 'brand': 'academy.ajarproductions.com', 'revenue': training_revenue, 'category': 'subscription training', 'coupon': offer_str, 'quantity': data.academy_included_users } )
        productsGA4.push( { 'item_id': trainingName, 'item_name': trainingName, 'price': training_revenue, 'item_brand': 'academy.ajarproductions.com', 'item_category': 'subscription training', 'coupon': offer_str, 'quantity': data.academy_included_users, 'affiliation': 'in5 checkout page', 'discount': 0.00 } )
      }

      window.dataLayer.push( { ecommerce: null } )
      window.dataLayer.push( { event: 'purchaseTransactionGA4', ecommerce: { 'currency': 'USD', 'value': revenue, 'tax': 0.00, 'shipping': 0.00, 'affiliation': 'in5 checkout page', 'transaction_id': data.order, 'coupon': offer_str, 'items': productsGA4 } } )

      window.dataLayer.push( { ecommerce: null } )
      window.dataLayer.push( { 'event': 'purchaseTransactionGA3', 'ecommerce': { 'purchase': { 'actionField': { 'id': data.order, 'affiliation': 'in5 checkout page', 'revenue': revenue, 'tax': 0.00, 'shipping': 0.00 }, 'products': productsGA3 } } } )
    } catch ( err ) { }
  }

  modifyOrder ( data, force ) {
    $.colorbox.close()
    if ( this.testMode ) console.log( data )
    var old_plan_id = plan_id, old_offer = offer_str, old_qty = qty
    plan_id = 'in5.v3.' + data.plan
    plan_int = data.billing_options
    qty = data.qty || 1

    if ( !force && this.hasPushState ) {
      var newHref = window.location.href.split( 'plan=' + old_plan_id.split( 'in5.v3.' ).join( '' ) ).join( 'plan=' + data.plan )
      newHref = this.updateURLString( newHref, 'academy_included', data.academy_included )
      newHref = this.updateURLString( newHref, 'academy_included_plan', data.academy_included_plan )
      newHref = this.updateURLString( newHref, 'academy_included_period', data.academy_included_period )
      newHref = this.updateURLString( newHref, 'academy_included_users', data.academy_included_users )
      if ( newHref.indexOf( 'qty' ) > -1 ) newHref = newHref.split( 'qty=' + old_qty ).join( 'qty=' + qty )
      window.history.pushState( null, document.title, newHref )
    }

    if ( data.offer && data.offer != 'none' ) {
      offer_str = data.offer
      offer_verify = data.verify
    }

    var hasTraining = data.academy_included == '1', $academy_included = $( 'input#academy_included' ),
      hadTraining = $academy_included.val() == '1'
    var trainingChange = hasTraining ? ( hadTraining ? 'kept' : 'added' ) : ( hadTraining ? 'removed' : 'none' )
    if ( hasTraining ) {
      $( 'input#academy_included_plan' ).val( data.academy_included_plan )
      $( 'input#academy_included_period' ).val( data.academy_included_period )
      $( 'input#academy_included_users' ).val( data.academy_included_users )
      $academy_included.val( '1' ).trigger( 'change' )
    } else {
      $academy_included.val( '0' ).trigger( 'change' )
    }

    $.post( this.ajaxURL, { 'action': 'in5v3_price_details', 'plan': plan_id, 'offer': offer_str, 'verify': offer_verify, 'mode': mode, 'qty': qty, 'academy_included': data.academy_included, 'academy_included_period': data.academy_included_period, 'academy_included_plan': data.academy_included_plan, 'academy_included_users': data.academy_included_users },
      ( data ) => {
        this.updateTrainingDetails( data.training_details )
        $( '.planName' ).text( data.plan_name )
        $( '.amount' ).html( this.getDollarFormat( data.plan_price ) )
        if ( data.discount_amount ) {
          $( '.discount_name' ).text( data.discount_name )
          $( '.discount_amount' ).html( this.getDollarFormat( data.discount_amount ) )
        } else {
          $( '.discount_name' ).text( '' )
          $( '.discount_amount' ).text( '' )
        }
        $( '.total' ).html( this.getDollarFormat( data.order_total ) )
        if ( qty > 1 ) $( '.quantity_amount' ).text( qty ).parents( 'tr' ).show()
      }, 'json' ).fail( () => {
        alert( 'Sorry, we made an error somewhere. Modify order failed.' )
      } )
    this.checkExistingCustomer()
  }

  updateTrainingDetails ( d ) {
    this.$details.find( '.training-plan' ).text( d.invoiceName )
    this.$details.find( '.training-users' ).text( d.user_str )
    this.$details.find( '.training-amount' ).html( this.getDollarFormat( d.total_price ) )
  }

  checkExistingCustomer () {
    if ( auth.length || !$( 'input#email' ).val().length ) return false
    var obj = $( { 'action': 'existing_customer', 'plan': plan_id, 'offer': offer_str, 'verify': offer_verify, 'mode': mode, 'qty': qty } ).addValueToObject( 'input#email', 'email' )
    if ( this.testMode ) console.log( obj )
    $.post( this.ajaxURL, obj[ 0 ], ( data ) => {
      if ( this.testMode ) console.log( data )
      if ( !data.existing ) return false
      this.upgradeData = {}
      var newPlanLevel = parseInt( plan_id.split( '.' )[ 3 ] )
      var subs = data.subscriptions, sub0 = subs.length ? subs[ 0 ] : null
      $( '.order_email' ).text( $( 'input#email' ).val() )
      if ( sub0 ) {
        $( '.old_plan_name' ).text( sub0.plan_name )
        var levelChange = newPlanLevel > data.accountLevel
        var quantChange = qty - sub0.qty
        var periodChange = 0
        switch ( plan_int ) {
          case 'monthly': case 'month': periodChange = ( sub0.plan_int == 'year' ) ? -1 : 0; break
          case 'annual': case 'year': periodChange = ( sub0.plan_int == 'month' ) ? 1 : 0; break
        }
        var isUpgrade = ( levelChange > 0 || ( levelChange == 0 && ( quantChange > 0 || periodChange > 0 ) ) )
        var isDowngrade = !isUpgrade && ( levelChange < 0 || ( levelChange == 0 && ( quantChange < 0 || periodChange < 0 ) ) )
        if ( isUpgrade ) {
          var $modal = $( '#upgrade-modal' )
          $modal.find( '#upgrade-existing-btn' ).one( 'click', () => {
            this.upgradeData = { 'sub_id': sub0.sub_id, 'cust_id': data.cust_id, 'type': 'upgrade' }
            $( '.discount_name' ).text( 'Credit for old plan' )
            $( '.discount_amount' ).text( 'TBD' )
            $.colorbox.close()
          } )
          $.colorbox( { inline: true, width: '94%', height: '90%', maxWidth: '500px', href: $modal } )
        } else if ( isDowngrade ) {
          alert( 'It looks like you have an existing account under ' + $( 'input#email' ).val() + '.\r\rProceeding would create a new account.\r\rIf you would like to instead downgrade your existing ' + sub0.plan_name + ' plan, send an email to support@ajarproductions.com.' )
        } else {
          alert( 'It looks like you have an existing account under ' + $( 'input#email' ).val() + '.\r\rProceeding would create an additional (new) account.\r\rIf this is a mistake or you have any questions, feel free to contact us at support@ajarproductions.com.' )
        }
      } else {
        var $modal = $( '#reactivate-modal' )
        $modal.find( '#reactivate-existing-btn' ).one( 'click', () => {
          this.upgradeData = { 'cust_id': data.cust_id, 'type': 'reactivate' }
          $.colorbox.close()
        } )
        $.colorbox( { inline: true, width: '94%', height: '90%', maxWidth: '500px', href: $modal } )
      }
    }, 'json' ).fail( ( xhr ) => {
      if ( this.testMode ) console.log( xhr.responseText )
    } )
  }

  openModifyOrder () {
    var plan = plan_id.split( '.' )[ 3 ], targ, maxW = '100%', maxH = '100%'
    var academyInfo = $( 'input#academy_included, input#academy_included_plan, input#academy_included_period, input#academy_included_users' ).serialize()
    switch ( plan ) {
      case 'ent':
        targ = 'purchase_modals/enterprise.two-one.php?action=modify&qty=' + $( '.quantity_amount' ).text() + '&plan=' + plan_id + '&' + academyInfo
        maxW = 900; maxH = 760
        break
      default: targ = 'modify_order.two-one.php?' + academyInfo
    }
    $.colorbox( { href: targ, iframe: true, width: '94%', height: '90%', maxHeight: maxH, maxWidth: maxW, className: 'solid' } )
  }

  getDollarFormat ( amt, shorten ) {
    amt = parseFloat( amt )
    var str = amt.toString()
    if ( shorten && str.indexOf( '.' ) < 0 ) return amt
    var arr = ( Math.round( amt * 100 ) * .01 ).toFixed( 2 ).split( '.' )
    return arr[ 0 ].toString().replace( /\B(?=(\d{3})+(?!\d))/g, ',' ) + '.<span class="cents">' + arr[ 1 ] + '</span>'
  }

  updateURLString ( str, key, val ) {
    if ( str.indexOf( key ) < 0 ) {
      str = str.replace( /\?/, '?' + key + '=' + val + '&' )
    } else {
      var reg = new RegExp( key + '\\=[^&]+', 'g' )
      str = str.replace( reg, key + '=' + val )
    }
    return str
  }

  unserialize ( data ) {
    data = data.split( '&' )
    var response = {}
    for ( var k in data ) {
      var newData = data[ k ].split( '=' )
      response[ newData[ 0 ] ] = newData[ 1 ]
    }
    return response
  }

  logAndCheckAttempts () {
    var key = 'paymentAttempts', softLimit = 8, dayLimit = 2
    var stored = localStorage.getItem( key )
    stored = stored ? JSON.parse( stored ) : []
    var now = new Date().getTime()
    stored.push( now )
    localStorage.setItem( key, JSON.stringify( stored ) )
    if ( stored.length < softLimit ) return true
    stored.sort()
    var i = stored.length - 1, day = 1000 * 60 * 60 * 24, c = 0
    while ( i-- ) {
      if ( now - stored[ i ] < day ) {
        c++
        if ( c > dayLimit ) return false
      } else return true
    }
    return true
  }

  backToStep ( e ) {
    e.preventDefault()
    var goTo = parseInt( $( e.currentTarget ).attr( 'data-go-to-step' ) ) || this.currentStep - 2
    $( '.checkout-steps' ).each( function () {
      $( this ).find( 'li' ).each( function ( i ) {
        if ( i > goTo ) $( this ).removeClass( 'done completed' )
      } )
    } )
    this.goToStep( goTo )
    return false
  }
}

function onCaptchaSubmit ( token ) {
  $( 'button#submitpayment' ).trigger( 'captcha-complete', { 'captcha_token': token } )
}

$.validator.addMethod( 'ccvalidate', function ( value, element ) {
  var $el = $( element )
  return ( mode === 'test' ) || $el.hasClass( 'jp-card-valid' ) && $el.hasClass( 'identified' )
}, 'invalid credit card number' )

$.validator.addMethod( 'ccexpvalidate', function ( value, el ) {
  return $( el ).val().match( /^[0-9]{2}\s*\/\s*[0-9]{2}$/ )
}, 'Try format MM/YY' )

$.fn.extend( {
  animateAndReset: function ( className, onComplete ) {
    return this.addClass( className ).one( 'webkitAnimationEnd oanimationend oAnimationEnd msAnimationEnd animationend',
      function () { $( this ).removeClass( className ); if ( onComplete ) onComplete(); return false } )
  },
  addValueToObject: function ( jqstr, propName ) {
    var $j = $( jqstr )
    if ( !$j.length ) return this
    switch ( $j.attr( 'type' ) ) {
      case 'checkbox': this.prop( propName, $j.is( ':checked' ) ); break
      default:
        var val = $j.val()
        if ( val.length ) this.prop( propName, val ); break
    }
    return this
  }
} )

window.Checkout = Checkout
